import React from "react";
import { HashLink as Link } from "react-router-hash-link";
import styles from "./solutions2.module.css";

class Solutions2 extends React.Component {
  render() {
    const { detect } = require("detect-browser");
    const browser = detect();
    const firefox = browser.name === "firefox"
    return (
      <div className={styles.container} style={{paddingBottom: firefox ? "5em" : "2em"}}>
        <div className={styles.caption2}>
          Системы мониторинга и управления объектами
        </div>
        <br />
        <div>
          Во многих отраслях промышленности и жилищно-коммунального хозяйства
          необходимо контролировать территориально-распределенные объекты,
          например:
        </div>
        <ul>
          <li>газовые подстанции;</li>
          <li>электрические подстанции;</li>
          <li>дата-центры;</li>
          <li>системы освещения;</li>
          <li>холодильные камеры;</li>
          <li>дачи;</li>
        </ul>
        <div>На этих объектах нужно контроллировать различные параметры:</div>
        <ul>
          <li>контроль доступа;</li>
          <li>температура;</li>
          <li>давление;</li>
          <li>влажность;</li>
          <li>загазованность;</li>
          <li>и т.д.</li>
        </ul>
        <div>
          Связь с объектами может осуществляться по различным каналам связи:
        </div>
        <ul>
          <li>GSM/GPRS;</li>
          <li>интернет;</li>
          <li>локальная сеть;</li>
          <li>радиосеть ZigBee.</li>
        </ul>
        <div>
          Наиболее простым и экономичный вариант системы измерение и управления
          строится на базе GSM/GPRS модема AnCom со встроенным микроконтролером.
          Встроенный микроконтролер имеет 8 аналогово-дискретных входа и два
          оптореле. Модем постоянно находится в режиме подключение к центральном
          серверу и передает следующую информацию:
        </div>
        <ul>
          <li>изменение состояния дискретных входов;</li>
          <li>значения аналоговых сигналов.</li>
        </ul>
        <div>
          Для увеличение надежности модем может оснащятся двумя SIM-картами
          разным операторов сотовой связи. При необходимости модем и датчики
          подключаеются к источнику бесперебойного питания.
        </div>
        <br />
        <div>Центральный сервер выполняет следующие функции:</div>
        <ul>
          <li>сбор и архивирование данных с объектов;</li>
          <li>предоставление доступа к данным через веб-интерфейс;</li>
          <li>
            оповещение о событиях по SMS, e-mail, jabber (мгновенные сообщения
            через интернет).
          </li>
        </ul>
        <div>
          Если Вы хотите узнать больше о предлагаемых нами технических решениях -{" "}
          <Link to="/contacts">
            обращайтесь к нам
            </Link>
          .
        </div>
      </div>
    );
  }
}

export default Solutions2;
